module.exports = __webpack_public_path__ + "media/pristine.a2050abb.mp3";